import { useEffect, useState } from "react";

export function useActiveChild() {
  const [child, setChild] = useState(() => {
    try {
      const raw = localStorage.getItem("active_child");
      return raw ? JSON.parse(raw) : null;
    } catch {
      return null;
    }
  });

  useEffect(() => {
    const onStorage = () => {
      try {
        const raw = localStorage.getItem("active_child");
        setChild(raw ? JSON.parse(raw) : null);
      } catch {
        setChild(null);
      }
    };
    window.addEventListener("storage", onStorage);
    return () => window.removeEventListener("storage", onStorage);
  }, []);

  return child;
}
